export function isEmpty(value: any): boolean {
  return !!(value === undefined || value == null || value.length <= 0);
}
